<template>
  <v-dialog v-model="config.status.active" max-width="600px">
    <v-card class="dialog">
      <v-card-title class="primary amber blue-grey--text text--darken-4">
        <span class="headline">{{ form.id ? '送金の編集' : '送金の追加' }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12">
                <v-combobox required
                  v-model="form.type"
                  label="送金方法"
                  maxlength="10"
                  :items="meta.type"
                  :rules="rules.type"
                />
              </v-col>
              <v-col cols="12">
                <v-menu lazy offset-y full-width
                  v-model="config.datepickers.date"
                  transition="scale-transition"
                  min-width="290px"
                  :close-on-content-click="false"
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field readonly
                      v-model="printFormDate"
                      label="完了日付"
                      v-on="on"
                      :append-icon="form.date ? 'fal fa-times' : null"
                      @click:append="form.date = ''"
                    />
                  </template>
                  <v-date-picker
                    v-model="form.date"
                    locale="ja"
                    color="amber"
                    :day-format="date => new Date(date).getUTCDate()"
                    @input="config.datepickers.date = false"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorProgsModalsTransfer',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        },
        datepickers: {
          date: false
        }
      },
      meta: {
        type: [
          '国内送金',
          '海外送金',
          'カード決済'
        ]
      },
      form: {
        valid: true,
        id: '',
        type: '',
        date: ''
      },
      rules: {
        type: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      const type = this.form.id ? 'update' : 'insert'
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/' + type + '/item/meta', {
            id: this.form.id,
            cid: this.form.cid,
            type: 'transfer',
            form: {
              date: this.form.date,
              type: this.form.type
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', {
                id: this.form.cid,
                type: 'transfer',
                value: {
                  sid: type === 'update' ? this.form.id : res.data.data,
                  type: this.form.type,
                  date: this.form.date
                }
              })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      const { id, cid, clientId, type, date } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        cid: cid,
        clientId: clientId,
        type: type,
        date: date
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    printFormDate () {
      return (this.form.date) ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    }
  }
}
</script>
